"use client";

import { useHashScrollToElement } from "@/hooks/use-hash-scroll-to-element";

/**
 * Client-only: scrolls to the hash target on load. Renders nothing.
 */
export const MarketingHashScroll = () => {
  useHashScrollToElement();
  return null;
};
